import dataEntityProp from "@mixins/data-entity-prop";
import Case from "case";

export default {

    data() {
        return {
            internalVal: undefined
        }
    },

    props: {
        initialVal: {
            type: [String, Number, Object, Array],
        }
    },

    created(){
        if(this.initialVal) {
            this.value = this.initialVal;
        }
    },

    computed: {
        value: {
            get() {
                if(this.entity) {
                    this.checkKey();
                    
                    return  this.$store.state[this.entity].filters[this.key];
                }

                return this.internalVal;
            },

            set(val) {
                if(this.entity) {

                    this.checkKey();
    
                    const mutation = `${Case.upper(this.entity)}_SET_FILTER`;
    
                    if (val !== this.$store.state[this.entity].filters[this.key])
                        this.$store.commit(mutation, {
                            key: this.key,
                            value: val,
                        });
                } else {
                    this.internalVal = val;
                    this.$emit('input', val)
                }
            },
        },
    },

    methods: {
        checkKey() {
            if (!this.key) throw new Error("Filter key not specified");
        },
    },

    mixins: [dataEntityProp],
};
